import React from 'react';
import s from './styles.module.css'
import Wrapper from "../wrapper";
import {Link, useLocation} from "react-router-dom";

const Footer = () => {
    const {pathname} = useLocation()
    return (
        <div className={s.footer}>
            <Wrapper>
                <div className={s.content}>
                    <h3>Din finansielle markedsplads i Danmark</h3>
                    <div className={s.navigate}>
                        <Link to={'/about'} style={{color: pathname === '/about' && '#039be5'}}>Om os</Link>
                        <Link to={'/advice'} style={{color: pathname === '/advice' && '#039be5'}}>Råd til låntagere</Link>
                        <Link to={'/conditions'} style={{color: pathname === '/conditions' && '#039be5'}}>Betingelser for at få et lån</Link>
                        <Link to={'/privacyPolicy'} style={{color: pathname === '/privacyPolicy' && '#039be5'}}>Privatlivspolitik</Link>
                        <Link to={'/cookiePolicy'} style={{color: pathname === '/cookiePolicy' && '#039be5'}}>Cookiepolitik</Link>
                        <Link to={'/contact'} style={{color: pathname === '/contact' && '#039be5'}}>Kontakt</Link>
                    </div>
                </div>
            </Wrapper>
        </div>
    );
};

export default Footer;
